import _ from 'lodash';
import moment from 'moment';
import { push } from 'connected-react-router';
import API from '../helpers/api';

export function authorizeWithTicket({ query }) {
	return async dispatch => {
		if (!query || !query.ticket) {
			dispatch(push(`/login?path=${_.get(query, 'path') || ''}`));
			return;
		}

		const res = await API.auth.casAuth({ ticket: query.ticket, path: query.path });
		if (res.meta.code !== 200) {
			dispatch(push('/unauthorized'));
			return;
		}

		// store response
		localStorage.setItem('cso_transport_booking_app', JSON.stringify({
			token: res.data.auth.token,
			booker: res.data.booker,
			last_login: moment()
		}));

		// Navigate to specified page
		if (query.path && query.path !== '/' && query.path !== '') {
			dispatch(push(query.path));
			return;
		}

		// Navigate to next page
		dispatch(push('/bookings'));
	};
}